var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Login", {
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c("span", { attrs: { id: "loginTitle" } }, [
              _vm._v(_vm._s(_vm.$tc("Company", 1)))
            ]),
            _vm._v(" "),
            _c("span", { attrs: { id: "loginMessage" } }, [
              _vm._v(_vm._s(_vm.$t("ChooseCompanyLoginMessage")))
            ])
          ]
        },
        proxy: true
      },
      {
        key: "form",
        fn: function() {
          return [
            _c(
              "form",
              {
                staticClass: "loginForm",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "main-login-form-container" }, [
                  _c(
                    "div",
                    { staticClass: "company-div" },
                    [
                      _c("span", { staticClass: "login-input-label" }, [
                        _vm._v(_vm._s(_vm.$tc("Company", 1)))
                      ]),
                      _vm._v(" "),
                      _c("treeselect", {
                        staticClass:
                          "loginInput form-input-select select-company",
                        class: { fieldErrorInput: _vm.badCompany },
                        attrs: {
                          options: _vm.companies,
                          "load-options": _vm.loadCompanies,
                          placeholder: null,
                          clearable: false,
                          searchable: false,
                          normalizer: _vm.normalizer
                        },
                        model: {
                          value: _vm.selectedCompanyID,
                          callback: function($$v) {
                            _vm.selectedCompanyID = $$v
                          },
                          expression: "selectedCompanyID"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.badCompany
                  ? _c(
                      "div",
                      {
                        staticClass: "field-error-div",
                        staticStyle: { "padding-top": "4px" }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("ChooseCompany")) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "button",
        fn: function() {
          return [
            _c(
              "v-btn",
              {
                staticClass: "signInInput",
                attrs: {
                  type: "submit",
                  loading: _vm.loading,
                  disabled: _vm.selectedCompanyID === null,
                  color: "accent--text",
                  outlined: ""
                },
                on: { click: _vm.submit }
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("Continue")) + "\n    ")]
            )
          ]
        },
        proxy: true
      },
      {
        key: "logoutButton",
        fn: function() {
          return [
            _c(
              "v-btn",
              {
                staticClass: "signInInput logoutButton",
                attrs: {
                  type: "execute",
                  loading: _vm.loading,
                  disabled: false,
                  color: "accent--text",
                  outlined: ""
                },
                on: { click: _vm.logout }
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("Logout")) + "\n    ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66b5b45c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b5b45c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/LoginCompanySelection.vue
// module id = null
// module chunks = 